/* B&M Gift — Cart Design Bundles
 * Shows design bundle cards on the cart page.
 * Reads line item properties from cart.js and renders a visual summary.
 */
(() => {
  'use strict';
  console.log('[bmgift-cart] script loaded, pathname:', window.location.pathname);
  function money(cents) { return '\u00a3' + (cents / 100).toFixed(2); }

  function getProp(item, name) {
    if (!item.properties) return null;
    if (Array.isArray(item.properties)) {
      const p = item.properties.find(x => x.name === name);
      return p ? p.value : null;
    }
    return item.properties[name] || null;
  }

  function groupByDesign(items) {
    const groups = new Map();
    items.forEach(item => {
      const did = getProp(item, '_design_id');
      if (!did) return;
      if (!groups.has(did)) {
        groups.set(did, { designId: did, baseItem: null, charmItems: [], allKeys: [], total: 0 });
      }
      const g = groups.get(did);
      g.allKeys.push(String(item.key));
      g.total += item.final_line_price;
      if (getProp(item, '_layout')) g.baseItem = item;
      else g.charmItems.push(item);
    });
    return groups;
  }

  async function removeBundle(keys) {
    const updates = {};
    keys.forEach(k => { updates[k] = 0; });
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
    window.location.reload();
  }

  function renderBundles(groups) {
    // Remove any previously rendered bundles
    document.querySelectorAll('.bmgift-bundles-section').forEach(el => el.remove());

    if (groups.size === 0) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'bmgift-bundles-section';

    for (const [, group] of groups) {
      const preview = group.baseItem ? getProp(group.baseItem, 'Design preview') : null;
      const layout = (group.baseItem ? getProp(group.baseItem, '_layout') : null) || 'Custom Design';
      const editor = group.baseItem ? getProp(group.baseItem, '_editor_url') : null;

      const card = document.createElement('div');
      card.className = 'bmb-card';
      card.innerHTML = `
        <div class="bmb-row">
          ${preview ? `<img class="bmb-img" src="${preview}" alt="Your design" />` : '<div class="bmb-img bmb-img--empty">\ud83c\udfa8</div>'}
          <div class="bmb-body">
            <div class="bmb-title">\ud83c\udfa8 ${layout}</div>
            <div class="bmb-meta">
              ${group.baseItem ? '<span>' + group.baseItem.product_title + '</span>' : ''}
              <span>${group.charmItems.length} charm${group.charmItems.length !== 1 ? 's' : ''}</span>
            </div>
            <div class="bmb-total">${money(group.total)}</div>
          </div>
          <div class="bmb-btns">
            ${editor ? `<a href="${editor}" class="bmb-btn bmb-btn--edit">\u270f\ufe0f Edit</a>` : ''}
            <button class="bmb-btn bmb-btn--remove">\ud83d\uddd1\ufe0f Remove</button>
          </div>
        </div>
        <details class="bmb-items">
          <summary>View ${1 + group.charmItems.length} items</summary>
          <ul>
            ${group.baseItem ? `<li><b>Base</b> ${group.baseItem.product_title} <span>${money(group.baseItem.final_line_price)}</span></li>` : ''}
            ${group.charmItems.map(i => `<li><b>\u00d7${i.quantity}</b> ${i.variant_title || i.product_title} <span>${money(i.final_line_price)}</span></li>`).join('')}
          </ul>
        </details>`;
      card.querySelector('.bmb-btn--remove')?.addEventListener('click', () => {
        if (confirm('Remove this entire design from your cart?')) removeBundle(group.allKeys);
      });
      wrapper.appendChild(card);
    }

    // Insert before the first section on the cart page or at the top of main
    const target = document.querySelector('main') || document.querySelector('.cart-page') || document.body;
    target.prepend(wrapper);
  }

  function injectStyles() {
    if (document.getElementById('bmgift-bundle-css')) return;
    const s = document.createElement('style');
    s.id = 'bmgift-bundle-css';
    s.textContent = `
.bmgift-bundles-section{max-width:var(--page-width,1200px);margin:20px auto;padding:0 var(--padding-md,16px)}
.bmb-card{border:2px solid #f0e0e8;border-radius:14px;padding:18px;margin-bottom:12px;background:linear-gradient(135deg,#fffaf7,#fff5f8)}
.bmb-row{display:flex;align-items:center;gap:16px;flex-wrap:wrap}
.bmb-img{width:90px;height:90px;object-fit:cover;border-radius:10px;border:1px solid #eee;flex-shrink:0}
.bmb-img--empty{display:grid;place-items:center;font-size:32px;background:#fff5f7}
.bmb-body{flex:1;min-width:140px}
.bmb-title{font-size:16px;font-weight:600;margin-bottom:4px}
.bmb-meta{font-size:12px;color:#888;display:flex;flex-wrap:wrap;gap:8px}
.bmb-total{font-size:18px;font-weight:700;color:#222;margin-top:4px}
.bmb-btns{display:flex;flex-direction:column;gap:6px}
.bmb-btn{font-size:12px;padding:6px 12px;border-radius:8px;cursor:pointer;text-decoration:none;text-align:center;border:1px solid #ddd;background:#fff;color:#333;white-space:nowrap}
.bmb-btn--remove:hover{background:#fee;border-color:#e84878;color:#e84878}
.bmb-btn--edit:hover{background:#f0f0ff;border-color:#6366f1;color:#6366f1}
.bmb-items{margin-top:10px}
.bmb-items summary{font-size:12px;color:#777;cursor:pointer}
.bmb-items ul{list-style:none;padding:8px 0 0;margin:0}
.bmb-items li{display:flex;align-items:center;gap:8px;padding:4px 0;font-size:12px;color:#555}
.bmb-items li b{background:#f5e8eb;border-radius:4px;padding:1px 6px;font-size:10px;color:#e84878}
.bmb-items li span{margin-left:auto;font-weight:600;color:#333}`;
    document.head.appendChild(s);
  }

  async function run() {
    if (!window.location.pathname.includes('/cart')) return;
    injectStyles();

    const res = await fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' });
    if (!res.ok) return;
    const cart = await res.json();
    const groups = groupByDesign(cart.items || []);
    console.log('[bmgift-cart] design groups:', groups.size, 'from', cart.items.length, 'items');
    renderBundles(groups);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(run, 300));
  else setTimeout(run, 300);
})();
/* v2 */
